<template>
  <div class="share-order-details">
    <!-- 顶部导航 -->
    <div class="page-nav-header">
      <div class="header-logo">
        <img src="@/assets/shareOrder/logo-white.png" alt="小蜜蜂闪运" />
      </div>
      <div class="header-nav">
        <div class="nav-item" @click="goHome">首页</div>
        <div class="nav-item" @click="scrollToSection('#downloadApp')">下载APP</div>
        <div class="nav-item" @click="scrollToSection('#downloadApp')">小程序下单</div>
        <div class="nav-item" @click="scrollToSection('#aboutUs')">关于我们</div>
        <div class="nav-item" @click="scrollToSection('#linkPhone')">联系我们</div>
      </div>
    </div>

    <!-- 订单详情卡片 -->
    <div class="order-card">
      <!-- 订单信息栏 -->
      <div class="order-info-bar">
        <div class="order-number-box">
          <img class="bee-icon" src="@/assets/shareOrder/bee-icon.png" alt="" />
          <span class="order-number">订单单号：{{ orderData.orderNumber || '--' }}</span>
          <span class="copy-btn" @click="copyOrderNumber">复制</span>
        </div>
        <div class="order-state">{{ formatOrderNodeName() }}</div>
        <div class="order-time">
          <div v-if="pickupTimeTip" class="pickup-time-tip">{{ pickupTimeTip }}</div>
          {{ statusTimeDisplay.label }}：{{ formatShortTime(statusTimeDisplay.time) }}
        </div>
        <div class="order-city">
          <span class="city-name">{{ orderData.startCity || '--' }}</span>
          <img class="arrow-icon" src="@/assets/shareOrder/arrow-right.svg" alt="" />
          <span class="city-name">{{ orderData.endCity || '--' }}</span>
        </div>
      </div>

      <!-- 地图 -->
      <div class="map-container" ref="mapContainer" id="shareOrderMap"></div>

      <!-- 司机信息 -->
      <div class="driver-info" v-if="orderData.driver || orderData.car">
        <div class="driver-avatar">
          <img :src="driverAvatar" alt="" />
        </div>
        <div class="driver-detail">
          <div class="driver-name">{{ (orderData.driver && orderData.driver.driverName) || '--' }}</div>
          <div class="driver-car" v-if="orderData.car">
            {{ orderData.car.carPlateNumber }}&nbsp;&nbsp;{{ orderData.car.carTypeDetail }}
          </div>
        </div>
      </div>

      <!-- Tab 切换 -->
      <div class="tabs-bar">
        <div
          class="tab-item"
          v-for="tab in tabs"
          :key="tab.key"
          :class="{ active: activeTab === tab.key }"
          @click="handleTabClick(tab.key)"
        >
          {{ tab.label }}
          <span class="tab-underline" v-show="activeTab === tab.key"></span>
        </div>
      </div>
      <div class="tabs-divider"></div>

      <!-- 订单详情 -->
      <div class="tab-content" v-show="activeTab === 'detail'">
        <div class="order-fields">
          <div class="fields-column">
            <div class="field-item">
              <span class="field-label">预计提货时间：</span>
              <span class="field-value">{{ orderData.deliveryTime || '--' }}</span>
            </div>
            <div class="field-item">
              <span class="field-label">归属日期：</span>
              <span class="field-value">{{ orderData.belongToDate || '--' }}</span>
            </div>
            <div class="field-item">
              <span class="field-label">订单线路：</span>
              <span class="field-value">{{ orderData.transportLine || '--' }}</span>
            </div>
          </div>
          <div class="fields-column">
            <div class="field-item">
              <span class="field-label">货物名称：</span>
              <span class="field-value">{{ orderData.loadingCargoType || '--' }}</span>
            </div>
            <div class="field-item">
              <span class="field-label">货物信息：</span>
              <span class="field-value">{{ goodsInfo }}</span>
            </div>
            <div class="field-item">
              <span class="field-label">客户备注：</span>
              <span class="field-value">{{ orderData.remark || '--' }}</span>
            </div>
          </div>
          <div class="fields-column">
            <!-- <div class="field-item">
              <span class="field-label">合作公司：</span>
              <span class="field-value">{{ orderData.companyName || '--' }}</span>
            </div> -->
            <div class="field-item">
              <span class="field-label">下单信息：</span>
              <span class="field-value">{{ orderInfo }}</span>
            </div>
          </div>
        </div>
        <div class="address-block">
          <div class="address-block-title">装货地址</div>
          <div class="address-list">
            <div class="address-card" v-for="(addr, index) in loadingAddressList" :key="'load' + index">
              <div class="address-tag loading-tag">[发货地址{{ toChinese(index + 1) }}]</div>
              <div class="address-name">{{ addr.factoryName?addr.factoryName:addr.title || '--' }}</div>
              <div class="address-detail">{{ formatAddress(addr) }}</div>
              <div class="address-contact">
                <span class="contact-label">联系人：</span>
                <span class="contact-value">{{ formatContact(addr) }}</span>
              </div>
            </div>
            <div class="address-empty" v-if="!loadingAddressList.length">暂无装货地址</div>
          </div>
        </div>
        <div class="address-block">
          <div class="address-block-title">卸货地址</div>
          <div class="address-list">
            <div class="address-card" v-for="(addr, index) in unloadingAddressList" :key="'unload' + index">
              <div class="address-tag unloading-tag">[收货地址{{ toChinese(index + 1) }}]</div>
              <div class="address-name">{{ addr.factoryName?addr.factoryName:addr.title || '--' }}</div>
              <div class="address-detail">{{ formatAddress(addr) }}</div>
              <div class="address-contact">
                <span class="contact-label">联系人：</span>
                <span class="contact-value">{{ formatContact(addr) }}</span>
              </div>
            </div>
            <div class="address-empty" v-if="!unloadingAddressList.length">暂无卸货地址</div>
          </div>
        </div>
      </div>

      <!-- 物流节点 -->
      <div class="tab-content" v-show="activeTab === 'track'">
        <div class="track-list" v-if="trackList.length">
          <div class="track-item" v-for="(node, index) in trackList" :key="index">
            <div class="track-left">
              <img class="track-node-icon" src="@/assets/shareOrder/node-icon.svg" alt="" />
              <div class="track-line" v-if="index !== trackList.length - 1"></div>
            </div>
            <div class="track-content">
              <div class="track-name">{{ node.nodeName }}</div>
              <div class="track-info">
                <img class="track-clock-icon" src="@/assets/shareOrder/clock-icon.svg" alt="" />
                <span class="track-people" v-if="node.feedbackPeople">{{ node.feedbackPeople }}</span>
                <span class="track-time">{{ node.nodeTime }}</span>
                <span class="track-address" v-if="node.feedbackAddress">【{{ node.feedbackAddress }}】</span>
              </div>
              <div class="track-photos" v-if="getNodePhotos(node).length">
                <el-image
                  class="track-photo"
                  v-for="(photo, pIndex) in getNodePhotos(node)"
                  :key="pIndex"
                  :src="photo"
                  :preview-src-list="getNodePhotos(node)"
                  fit="cover"
                ></el-image>
              </div>
            </div>
          </div>
        </div>
        <div class="empty-tip" v-else>暂无物流节点信息</div>
      </div>

      <!-- 冷藏数据 -->
      <div class="tab-content" v-show="activeTab === 'cold'">
        <div class="cold-axis-title" v-show="hasColdData">
          <span>温度℃</span>
          <span>湿度（%）</span>
        </div>
        <div class="cold-chart" ref="coldChart" v-show="hasColdData"></div>
        <div class="empty-tip" v-if="!hasColdData && !coldLoading">暂无冷藏数据</div>
        <div class="empty-tip" v-if="coldLoading">冷藏数据加载中...</div>
      </div>
    </div>

    <!-- 扫码下单 -->
    <download-app :contentText="contentText" id="downloadApp"></download-app>
    <!-- 关于我们 -->
    <about-us :contentText="contentText" id="aboutUs"></about-us>
    <!-- 服务范围 -->
    <div class="scope-of-services" v-if="contentText.aboutUs && contentText.aboutUs.scopeOfServices">
      <div class="container">
        <div class="server-title">
          <span class="text-title">{{ contentText.aboutUs.scopeOfServices.textTitle }}</span>
          <span class="latter-title">{{ contentText.aboutUs.scopeOfServices.latterTitle }}</span>
        </div>
        <div class="server-content">{{ contentText.aboutUs.scopeOfServices.content }}</div>
      </div>
    </div>
    <!-- 联系我们（底部） -->
    <link-phone :contentText="contentText" id="linkPhone"></link-phone>

    <!-- 右侧悬浮按钮 -->
    <div class="right-btn">
      <div class="suspension-icon" @click="backTopHandle">
        <div class="suspension-icon-item-icon">
          <img src="@/assets/homepages/back-top-icon.png" style="width:100%;height:100%" />
        </div>
        <div class="name">返回顶部</div>
      </div>
      <div class="suspension-icon online-customer-service-icon" @click="linkServerHandle" v-show="showLinkServe">
        <div class="suspension-icon-item-icon">
          <img src="@/assets/homepages/online-customer-service-icon.png" style="width:100%;height:100%" />
        </div>
        <div class="name">在线客服</div>
      </div>
    </div>
    <div v-if="showCustomerService">
      <customer-service ref="customerService" />
    </div>
  </div>
</template>

<script>
import downloadApp from '@/views/downloadAPP/index.vue';
import aboutUs from '@/views/aboutUs/index.vue';
import linkPhone from '@/views/contactUs/linkPhone/index.vue';
import customerService from '@/views/contactUs/customerService';
import beecargoOfficialWebText from '@/utils/beecargoOfficialWebText.json';
import { getShareOrderDetail, getColdDataDetail } from '@/api/shareOrderDetails';
import { directionDriving } from '@/api/beecargo/addressBook/logisticsDetails';
import { formatMinutes } from '@/utils';
import Donut from '@/utils/mapFun';

const CHINESE_NUMBERS = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];

export default {
  name: 'ShareOrderDetails',
  components: { downloadApp, aboutUs, linkPhone, customerService },
  data() {
    return {
      contentText: beecargoOfficialWebText,
      shareCode: '',
      orderData: {},
      tabs: [
        { key: 'detail', label: '订单详情' },
        { key: 'track', label: '物流节点' },
        { key: 'cold', label: '冷藏数据' }
      ],
      activeTab: 'detail',
      coldLoading: false,
      hasColdData: false,
      map: null,
      acceptedOverlay: null,
      loadedAddressOverlays: [],
      signedAddressOverlays: [],
      currentTimestamp: Date.now(),
      pickupTimer: null,
      chart: null,
      showCustomerService: false,
      showLinkServe: true
    };
  },
  computed: {
    loadingAddressList() {
      return this.orderData.loadingAddressList || [];
    },
    unloadingAddressList() {
      return this.orderData.unloadingAddressList || [];
    },
    trackList() {
      return this.orderData.trackList || [];
    },
    latestTrackNode() {
      return this.trackList.length ? this.trackList[0] : null;
    },
    statusTimeDisplay() {
      const code = this.orderData.orderLinkCode;
      const getNodeTime = (nodeCode) => {
        const node = this.trackList.find(item => item.nodeCode === nodeCode);
        return node ? node.nodeTime : '';
      };
      const rules = [
        { codes: ['接单', 'start', '前往装货地'], label: '预计提货时间', time: this.orderData.deliveryTime },
        { codes: ['arriveDelivery', 'beginningLoading', 'completionLoading'], label: '到达提货时间', time: getNodeTime('arriveDelivery') },
        { codes: ['leavePhoto'], label: '预计送达时间', time: this.orderData.estimatedArrivalTime },
        { codes: ['arriveUploads', 'arriveReceiving', 'breakBulk', 'completeDischarge'], label: '到达卸货时间', time: getNodeTime('arriveUploads') },
        { codes: ['receipt'], label: '签收时间', time: getNodeTime('receipt') }
      ];
      const matched = rules.find(rule => rule.codes.includes(code));
      return matched || { label: '预计提货时间', time: this.orderData.deliveryTime };
    },
    pickupTimeTip() {
      const pickupCodes = ['接单', 'start', '前往装货地'];
      const currentCode = (this.trackList[0] && this.trackList[0].nodeCode)
        || this.orderData.orderLinkCode;
      if (!pickupCodes.includes(currentCode) || !this.orderData.deliveryTime) return '';
      return this.formatPickupCountdown(this.orderData.deliveryTime, this.currentTimestamp);
    },
    driverAvatar() {
      const head = this.orderData.driver && this.orderData.driver.headSculpture;
      return head || require('@/assets/image/map-driver-icon.png');
    },
    goodsInfo() {
      const d = this.orderData;
      const parts = [];
      if (d.loadingCargoNumber != null && d.loadingCargoNumber !== '') {
        parts.push(`${d.loadingCargoNumber}${d.loadingCargoType || '件'}`);
      }
      if (d.totalWeight) parts.push(`${d.totalWeight}T`);
      if (d.totalVolume) parts.push(`${d.totalVolume}m³`);
      return parts.join(' ') || '--';
    },
    orderInfo() {
      const d = this.orderData;
      if (!d.orderCreateBy && !d.createTime) return '--';
      return `${d.orderCreateBy || ''}  ${d.createTime || ''}`;
    }
  },
  created() {
    this.shareCode = this.$route.query.shareCode || '';
  },
  mounted() {
    this.loadOrderDetail();
    this.pickupTimer = setInterval(() => {
      this.currentTimestamp = Date.now();
      // 接单气泡不是 Vue 模板，需主动重建才能实时刷新提货倒计时。
      const currentNode = this.trackList[0];
      const position = this.orderData.position;
      if (currentNode && currentNode.nodeCode === '接单' && this.map
        && position && Number(position.latitude) && Number(position.longitude)) {
        this.showAcceptedOrder(new window.TMap.LatLng(
          Number(position.latitude),
          Number(position.longitude)
        ));
      }
    }, 60000);
  },
  beforeDestroy() {
    if (this.pickupTimer) clearInterval(this.pickupTimer);
    if (this.acceptedOverlay) {
      this.acceptedOverlay.destroy();
      this.acceptedOverlay = null;
    }
    this.destroyLoadedAddressOverlays();
    this.destroySignedAddressOverlays();
    if (this.map) {
      this.map.destroy();
      this.map = null;
    }
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  methods: {
    formatOrderNodeName() {
      if (this.orderData.trackList && this.orderData.trackList.length > 0) return this.orderData.trackList[0].nodeName;
      const state = Number(this.orderData.state);
      if (state >= 6) return '已签收';
      if (state === 5) return '运输中';
      if (state > 0) return '等待运输';
      return '--';
    },
    formatPickupCountdown(deliveryTime, currentTimestamp = Date.now()) {
      if (!deliveryTime) return '提货时间待定';
      const pickupTime = new Date(String(deliveryTime).replace(/-/g, '/')).getTime();
      if (!Number.isFinite(pickupTime)) return '提货时间待定';
      const remaining = pickupTime - currentTimestamp;
      if (remaining <= 0) return '已超时';
      const totalMinutes = Math.ceil(remaining / 60000);
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return `剩余${hours}小时${minutes}分钟提货`;
    },
    formatShortTime(value) {
      if (!value) return '--';
      const parts = String(value).split(' ');
      return parts.length > 1 ? `${parts[0].slice(5).replace('-', '月')}日 ${parts[1].slice(0, 5)}` : value;
    },
    /* ==================== 数据请求 ==================== */
    async loadOrderDetail() {
      if (!this.shareCode) {
        this.$message.warning('缺少分享码参数');
        return;
      }
      try {
        const res = await getShareOrderDetail({ shareCode: this.shareCode });
        this.orderData = res.data || {};
        this.$nextTick(() => {
          this.initMap();
        });
      } catch (e) {
        console.error('获取订单详情失败', e);
      }
    },
    handleTabClick(key) {
      this.activeTab = key;
      if (key === 'cold') {
        this.loadColdData();
      }
    },
    async loadColdData() {
      if (this.coldLoading) return;
      this.coldLoading = true;
      try {
        const res = await getColdDataDetail({ shareCode: this.shareCode });
        const data = res.data || {};
        const temperaturePoints = this.parseSensorList(data.temperatureList);
        const humidityPoints = this.parseSensorList(data.humidityList);
        this.hasColdData = !!(temperaturePoints.length || humidityPoints.length);
        if (this.hasColdData) {
          await this.renderColdChart(temperaturePoints, humidityPoints);
        }
      } catch (e) {
        this.hasColdData = false;
        console.error('获取冷藏数据失败', e);
      } finally {
        this.coldLoading = false;
      }
    },
    // 列表项的 sensorValue 为 JSON 字符串，传感器数值放大了 10 倍。
    // 与冷藏数据弹窗保持一致：每组只保留首条、整点和末条数据。
    parseSensorList(list) {
      const pointMap = new Map();
      (Array.isArray(list) ? list : []).forEach(item => {
        let sensorValue = [];
        if (item && Array.isArray(item.sensorValue)) {
          sensorValue = item.sensorValue;
        } else if (item && this.jsonString(item.sensorValue)) {
          sensorValue = JSON.parse(item.sensorValue);
        }
        sensorValue.forEach((sensorItem, sensorIndex) => {
          if (
            sensorIndex !== 0 &&
            !this.isHourly(sensorItem.lastUpdateTime) &&
            sensorIndex !== sensorValue.length - 1
          ) return;
          const time = Number(sensorItem.lastUpdateTime);
          const value = +this.$math(sensorItem.sensorValue, 10).divide();
          if (Number.isFinite(time) && Number.isFinite(value)) {
            pointMap.set(time, [time, value]);
          }
        });
      });
      return Array.from(pointMap.values()).sort((a, b) => a[0] - b[0]);
    },
    /**
     * 是否json字符串
     */
    jsonString(value) {
      if (typeof value == 'string') {
        try {
          var obj = JSON.parse(value);
          if (typeof obj == 'object' && obj) {
            return true;
          } else {
            return false;
          }
        } catch (e) {
          return false;
        }
      }
      return false;
    },
    // 判断你是否整点
		isHourly(timestamp) {
		  const date = new Date(timestamp);
		  const minutes = date.getMinutes();
		  const seconds = date.getSeconds();
		
		  if (minutes === 0 && seconds === 0) {
		    return true;
		  } else {
		    return false;
		  }
		},
    /* ==================== 冷藏数据图表 ==================== */
    loadEcharts() {
      return new Promise((resolve, reject) => {
        if (window.echarts) {
          resolve();
          return;
        }
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://cdn.jsdelivr.net/npm/echarts@5.4.3/dist/echarts.min.js';
        document.head.appendChild(script);
        script.onload = () => resolve();
        script.onerror = () => {
          const backupScript = document.createElement('script');
          backupScript.type = 'text/javascript';
          backupScript.src = 'https://unpkg.com/echarts@5.4.3/dist/echarts.min.js';
          document.head.appendChild(backupScript);
          backupScript.onload = () => resolve();
          backupScript.onerror = () => reject(new Error('echarts 加载失败'));
        };
      });
    },
    async renderColdChart(temperaturePoints, humidityPoints) {
      await this.loadEcharts();
      await this.$nextTick();
      const echarts = window.echarts;
      if (!this.chart) {
        this.chart = echarts.init(this.$refs.coldChart);
        window.addEventListener('resize', this.resizeChart);
      }
      const formatTime = value => {
        const date = new Date(Number(value));
        const pad = n => (n < 10 ? '0' + n : '' + n);
        if (Number.isNaN(date.getTime())) return '';
        return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
      };
      const formatFullTime = value => {
        const date = new Date(Number(value));
        const pad = n => (n < 10 ? '0' + n : '' + n);
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
      };
      const temperatureData = temperaturePoints;
      const humidityData = humidityPoints;
      this.chart.setOption({
        grid: { left: 60, right: 70, top: 40, bottom: 72 },
        legend: {
          left: 10,
          top: 0,
          itemWidth: 12,
          itemHeight: 4,
          textStyle: { color: '#3d3833', fontSize: 12 },
          data: ['温度', '湿度']
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0,0,0,0.75)',
          borderWidth: 0,
          textStyle: { color: '#ffffff', fontSize: 12 },
          formatter(params) {
            let html = params.length ? formatFullTime(params[0].axisValue) : '';
            params.forEach(p => {
              const value = Array.isArray(p.value) ? p.value[1] : p.value;
              if (value == null) return;
              const unit = p.seriesName === '温度' ? '℃' : '%';
              html += `<br/>${p.marker}${p.seriesName}：${value}${unit}`;
            });
            return html;
          }
        },
        xAxis: {
          type: 'time',
          boundaryGap: false,
          axisLabel: { color: '#241f1b', fontSize: 12, formatter: formatTime },
          axisLine: { lineStyle: { color: '#e5e5e5' } },
          axisTick: { show: false },
          splitLine: { show: false }
        },
        dataZoom: [
          {
            type: 'inside',
            xAxisIndex: 0,
            start: 0, end: 20
          },
          {
            type: 'slider',
            xAxisIndex: 0,
            bottom: 10,
            height: 20,
            showDetail: false,
            start: 0, end: 20
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            min: "dataMin",
            max: "dataMax",
            axisLabel: { color: '#3d3833', fontSize: 12 },
            splitLine: { lineStyle: { color: '#f0f0f0' } }
          },
          {
            type: 'value',
            min: "dataMin",
            max: "dataMax",
            axisLabel: { color: '#3d3833', fontSize: 12, formatter: '{value}%' },
            splitLine: { show: false }
          }
        ],
        series: [
          {
            name: '温度',
            type: 'line',
            smooth: true,
            showSymbol: false,
            connectNulls: true,
            yAxisIndex: 0,
            itemStyle: { color: '#0074e4' },
            lineStyle: { color: '#0074e4', width: 2 },
            data: temperatureData
          },
          {
            name: '湿度',
            type: 'line',
            smooth: true,
            showSymbol: false,
            connectNulls: true,
            yAxisIndex: 1,
            itemStyle: { color: '#86dc91' },
            lineStyle: { color: '#86dc91', width: 2 },
            data: humidityData
          }
        ]
      }, { notMerge: true });
      this.chart.resize();
    },
    resizeChart() {
      if (this.chart) this.chart.resize();
    },
    /* ==================== 地图 ==================== */
    async initMap() {
      try {
        await this.createMap();
      } catch (e) {
        console.error('地图脚本加载失败', e);
        return;
      }
      const TMap = window.TMap;
      if (!TMap || !this.$refs.mapContainer) return;

      const data = this.orderData;
      this.destroyLoadedAddressOverlays();
      this.destroySignedAddressOverlays();
      const currentNode = (data.trackList && data.trackList[0]) || {};
      const currentNodeCode = currentNode.nodeCode || currentNode.node;
      const currentCode = data.orderLinkCode || currentNodeCode;
      const isAccepted = currentNodeCode === '接单';
      const isLoadingOperationRoute = ['arriveDelivery', 'beginningLoading', 'completionLoading']
        .includes(currentNode.nodeCode);
      const isArriveUnloadingRoute = ['arriveUploads', 'arriveReceiving', 'breakBulk', 'completeDischarge']
        .includes(currentNode.nodeCode);
      const isHeadingToLoading = currentNode.nodeCode === '前往装货地'
        || currentNode.node === '前往装货地';
      const allLoadingCompleted = this.isAllLoadingCompleted(data);
      const isMovingToNextLoading = currentNode.nodeCode === 'leavePhoto'
        && (Array.isArray(data.shippingLocationItems) ? data.shippingLocationItems.length : 0)
          !== (Array.isArray(data.loadingAddressList) ? data.loadingAddressList.length : 0);
      const isHeadingToFirstUnloading = allLoadingCompleted || (data.orderLinkCode !== 'start'
        && currentNode.nodeCode === 'leavePhoto'
        && data.receivingLocationItems === null);
      // 地图线路中的装货地和卸货地均按 sortId 升序参与规划。
      const sortAddresses = list => list.slice()
        .sort((a, b) => Number(a.sortId || 0) - Number(b.sortId || 0));
      const loadingList = sortAddresses(
        (data.loadingAddressList || []).filter(item => item.latitude && item.longitude)
      );
      const unloadingList = sortAddresses(
        (data.unloadingAddressList || []).filter(item => item.latitude && item.longitude)
      );
      const receivingLocationList = Array.isArray(data.receivingLocationItems)
        ? data.receivingLocationItems
        : [];
      const unloadingAddressCount = Array.isArray(data.unloadingAddressList)
        ? data.unloadingAddressList.length
        : 0;
      const isLastUnloadingArrival = ['arriveUploads','arriveReceiving','breakBulk','completeDischarge'].includes(currentNode.nodeCode)
        && unloadingAddressCount > 0
        && receivingLocationList.length === unloadingAddressCount;
      const isHeadingToNextUnloading = currentNode.nodeCode === 'completeDischarge'
        && data.orderLinkCode === 'leavePhoto'
        && receivingLocationList.length > 0
        && receivingLocationList.length < unloadingAddressCount;
      const shippingLocationCount = Array.isArray(data.shippingLocationItems)
        ? data.shippingLocationItems.length
        : 0;
      const loadingAddressCount = Array.isArray(data.loadingAddressList)
        ? data.loadingAddressList.length
        : 0;
      const isLastLoadingArrival = ['arriveDelivery','beginningLoading','completionLoading'].includes(currentNode.nodeCode)
        && loadingAddressCount > 0
        && shippingLocationCount === loadingAddressCount;
      // 装卸货操作阶段通常隐藏司机位置；完成某站卸货并离场时需同时展示司机 Marker。
      const operationStatusCodes = [
        'arriveDelivery', 'beginningLoading', 'completionLoading',
        'arriveUploads', 'arriveReceiving', 'breakBulk', 'completeDischarge'
      ];
      const shouldShowDriver = isHeadingToNextUnloading || ((isAccepted || isHeadingToLoading
        || (currentCode !== 'receipt' && !operationStatusCodes.includes(currentCode)))
        && currentNode.nodeCode !== 'completeDischarge');
      const position = shouldShowDriver && data.position
        && data.position.latitude
        && data.position.longitude
        ? data.position
        : null;

      // 地图中心：司机位置 > 第一个装货地址 > 默认(深圳)
      let center;
      if (position) {
        center = new TMap.LatLng(Number(position.latitude), Number(position.longitude));
      } else if (loadingList.length) {
        center = new TMap.LatLng(Number(loadingList[0].latitude), Number(loadingList[0].longitude));
      } else {
        center = new TMap.LatLng(22.53332, 113.93041);
      }

      this.map = new TMap.Map(this.$refs.mapContainer, {
        center,
        zoom: 10,
        showControl: false,
        mapStyleId: 'style1'
      });

      // 标记点
      const styles = {
        start: new TMap.MarkerStyle({
          width: 50,
          height: 52,
          anchor: { x: 16, y: 52 },
          src: require('@/assets/images/start-icon.png')
        }),
        end: new TMap.MarkerStyle({
          width: 50,
          height: 52,
          anchor: { x: 16, y: 52 },
          src: require('@/assets/images/end-address-icon.png')
        }),
        driver: new TMap.MarkerStyle({
          width: 50,
          height: 52,
          anchor: { x: 18, y: 52 },
          src: require('@/assets/images/driver-position-icon.png')
        })
      };
      const geometries = [];
      const allPoints = [];
      const loadingPoints = [];
      const unloadingPoints = [];
      let driverPoint = null;
      // 装卸货阶段使用对应地址展示当前状态 Marker。
      const operationStatusPoint = this.getOperationStatusPoint(data);
      const loadedAddressStatusPoints = this.getLoadedAddressStatusPoints(data, operationStatusPoint);
      const signedAddressStatusPoints = this.getSignedAddressStatusPoints(data, operationStatusPoint);
      loadingList.forEach((item, index) => {
        const latLng = new TMap.LatLng(Number(item.latitude), Number(item.longitude));
        geometries.push({ id: `start${index}`, styleId: 'start', position: latLng });
        loadingPoints.push(latLng);
        allPoints.push(latLng);
      });
      unloadingList.forEach((item, index) => {
        const latLng = new TMap.LatLng(Number(item.latitude), Number(item.longitude));
        geometries.push({ id: `end${index}`, styleId: 'end', position: latLng });
        unloadingPoints.push(latLng);
        allPoints.push(latLng);
      });
      if (position) {
        const latLng = new TMap.LatLng(Number(position.latitude), Number(position.longitude));
        driverPoint = latLng;
        geometries.push({ id: 'driver', styleId: 'driver', position: latLng });
        allPoints.push(latLng);
        if (isAccepted) this.showAcceptedOrder(latLng);
      }
      if (operationStatusPoint) {
        geometries.push({
          id: 'current-operation-status',
          styleId: operationStatusPoint.styleId,
          position: operationStatusPoint.position
        });
        allPoints.push(operationStatusPoint.position);
      }
      if (geometries.length) {
        new TMap.MultiMarker({
          map: this.map,
          styles,
          geometries
        });
      }
      if (operationStatusPoint) {
        this.showOperationStatus(operationStatusPoint);
      }
      if (loadedAddressStatusPoints.length) {
        this.showLoadedAddressStatuses(loadedAddressStatusPoints);
      }
      if (signedAddressStatusPoints.length) {
        this.showSignedAddressStatuses(signedAddressStatusPoints);
      }

      // 接单后优先从司机位置出发；缺少司机定位时仍展示全部装卸货地之间的路线。
      if (isAccepted && !isLastLoadingArrival) {
        const routePoints = (driverPoint ? [driverPoint] : []).concat(loadingPoints, unloadingPoints);
        if (routePoints.length > 1) {
          try {
            const route = await this.requestRoute(routePoints);
            new TMap.MultiPolyline({
              map: this.map,
              styles: {
                accepted: new TMap.PolylineStyle({
                  color: '#D9CBBE',
                  width: 9,
                  lineCap: 'round',
                  showArrow: true
                })
              },
              geometries: [{ id: 'accepted-route', styleId: 'accepted', paths: route.paths }]
            });
            allPoints.push(...route.paths);
          } catch (error) {
            console.error('接单路线规划失败', error);
          }
        }
      } else if (isLastLoadingArrival && loadingPoints.length) {
        const routeGeometries = [];
        const routeStyles = {
          travelled: new TMap.PolylineStyle({
            color: '#2E9CFF',
            width: 9,
            lineCap: 'round',
            showArrow: true
          }),
          remaining: new TMap.PolylineStyle({
            color: '#D9CBBE',
            width: 9,
            lineCap: 'round',
            showArrow: true
          })
        };

        const sortedShippingItems = data.shippingLocationItems.slice()
          .sort((a, b) => Number(a.sortId || 0) - Number(b.sortId || 0));
        const unusedLoadingPoints = loadingPoints.slice();
        const matchedLoadingPoints = sortedShippingItems.map(item => {
          const pointIndex = unusedLoadingPoints.findIndex(point => (
            Number(item.addrLatitude) === point.getLat()
            && Number(item.addrLongitude) === point.getLng()
          ));
          return pointIndex >= 0 ? unusedLoadingPoints.splice(pointIndex, 1)[0] : null;
        }).filter(Boolean);
        // 最后一个装货地操作期间，按定位记录 sortId 顺序连接已装货地与当前装货地。
        const operatedLoadingPoints = matchedLoadingPoints.length === loadingPoints.length
          ? matchedLoadingPoints
          : loadingPoints;
        if (operatedLoadingPoints.length > 1) {
          try {
            const travelledRoute = await this.requestRoute(operatedLoadingPoints);
            routeGeometries.push({
              id: 'completed-loading-route',
              styleId: 'travelled',
              paths: travelledRoute.paths
            });
            allPoints.push(...travelledRoute.paths);
          } catch (error) {
            console.error('装货地之间路线规划失败', error);
          }
        }
        const currentLoadingPoint = operatedLoadingPoints[operatedLoadingPoints.length - 1];
        const remainingPoints = [currentLoadingPoint].concat(unloadingPoints);
        if (remainingPoints.length > 1) {
          try {
            const remainingRoute = await this.requestRoute(remainingPoints);
            routeGeometries.push({
              id: 'last-loading-to-unloading-route',
              styleId: 'remaining',
              paths: remainingRoute.paths
            });
            allPoints.push(...remainingRoute.paths);
          } catch (error) {
            console.error('最后装货地到卸货地路线规划失败', error);
          }
        }
        if (routeGeometries.length) {
          new TMap.MultiPolyline({
            map: this.map,
            styles: routeStyles,
            geometries: routeGeometries
          });
        }
      } else if (isMovingToNextLoading && driverPoint && loadingPoints.length) {
        const orderItems = Array.isArray(data.shippingLocationItems) && data.shippingLocationItems.length
          ? data.shippingLocationItems
          : currentNode.shippingLocationItems;
        const shippingItems = Array.isArray(orderItems) ? orderItems : [];
        const completedItem = shippingItems[0];
        const completedLoadingPoint = completedItem
          ? loadingPoints.find(point => (
            Number(completedItem.addrLatitude) === point.getLat()
            && Number(completedItem.addrLongitude) === point.getLng()
          ))
          : null;
        // 未完成装货地以地址坐标未出现在装货定位记录中为准，并保持地址列表原有顺序。
        const pendingLoadingPoints = loadingPoints.filter(point => !shippingItems.some(item => (
          Number(item.addrLatitude) === point.getLat()
          && Number(item.addrLongitude) === point.getLng()
        )));
        const routeGeometries = [];
        const routeStyles = {
          travelled: new TMap.PolylineStyle({
            color: '#2E9CFF',
            width: 9,
            lineCap: 'round',
            showArrow: true
          }),
          remaining: new TMap.PolylineStyle({
            color: '#D9CBBE',
            width: 9,
            lineCap: 'round',
            showArrow: true
          })
        };

        if (completedLoadingPoint) {
          try {
            const travelledRoute = await this.requestRoute([completedLoadingPoint, driverPoint]);
            routeGeometries.push({
              id: 'completed-loading-to-driver-route',
              styleId: 'travelled',
              paths: travelledRoute.paths
            });
            allPoints.push(...travelledRoute.paths);
          } catch (error) {
            console.error('已完成装货地到司机位置路线规划失败', error);
          }
        }
        if (pendingLoadingPoints.length) {
          try {
            // 剩余线路从司机位置开始，依次经过所有未完成装货地和卸货地。
            const remainingPoints = [driverPoint].concat(pendingLoadingPoints, unloadingPoints);
            const [remainingRoute, distanceRoute] = await Promise.all([
              this.requestRoute(remainingPoints),
              this.requestRoute([driverPoint, pendingLoadingPoints[0]])
            ]);
            routeGeometries.push({
              id: 'driver-through-pending-loading-to-unloading-route',
              styleId: 'remaining',
              paths: remainingRoute.paths
            });
            this.showDistance(driverPoint, distanceRoute, '装货地');
            allPoints.push(...remainingRoute.paths);
          } catch (error) {
            console.error('司机经未完成装货地到卸货地路线规划失败', error);
          }
        }
        if (routeGeometries.length) {
          new TMap.MultiPolyline({
            map: this.map,
            styles: routeStyles,
            geometries: routeGeometries
          });
        }
      } else if (!isArriveUnloadingRoute && isLastUnloadingArrival) {
        const routePoints = loadingPoints.concat(unloadingPoints);
        if (routePoints.length > 1) {
          try {
            const route = await this.requestRoute(routePoints);
            new TMap.MultiPolyline({
              map: this.map,
              styles: {
                completed: new TMap.PolylineStyle({
                  color: '#2E9CFF',
                  width: 9,
                  lineCap: 'round',
                  showArrow: true
                })
              },
              geometries: [{
                id: 'all-locations-completed-route',
                styleId: 'completed',
                paths: route.paths
              }]
            });
            allPoints.push(...route.paths);
          } catch (error) {
            console.error('全部装卸货地路线规划失败', error);
          }
        }
      } else if (isHeadingToNextUnloading
        && driverPoint
        && unloadingPoints.length) {
        const getSortedLocationPoints = items => items.slice()
          .sort((a, b) => Number(a.sortId || 0) - Number(b.sortId || 0))
          .map(item => {
            const latitude = Number(item.addrLatitude);
            const longitude = Number(item.addrLongitude);
            return Number.isFinite(latitude) && Number.isFinite(longitude)
              ? new TMap.LatLng(latitude, longitude)
              : null;
          })
          .filter(Boolean);
        const operatedLoadingPoints = getSortedLocationPoints(
          Array.isArray(data.shippingLocationItems) ? data.shippingLocationItems : []
        );
        const operatedUnloadingPoints = getSortedLocationPoints(receivingLocationList);
        const nextUnloadingPoint = unloadingPoints.find(point => !receivingLocationList.some(item => (
          Number(item.addrLatitude) === point.getLat()
          && Number(item.addrLongitude) === point.getLng()
        ))) || unloadingPoints[receivingLocationList.length];
        if (nextUnloadingPoint) {
          const routeGeometries = [];
          const routeStyles = {
            travelled: new TMap.PolylineStyle({
              color: '#2E9CFF',
              width: 9,
              lineCap: 'round',
              showArrow: true
            }),
            remaining: new TMap.PolylineStyle({
              color: '#D9CBBE',
              width: 9,
              lineCap: 'round',
              showArrow: true
            })
          };

          // 已行驶线路严格按装货、卸货定位记录的 sortId 顺序连接到司机当前位置。
          const travelledPoints = (operatedLoadingPoints.length
            ? operatedLoadingPoints
            : loadingPoints).concat(operatedUnloadingPoints, driverPoint);
          if (travelledPoints.length > 1) {
            try {
              const travelledRoute = await this.requestRoute(travelledPoints);
              routeGeometries.push({
                id: 'operated-locations-to-driver-route',
                styleId: 'travelled',
                paths: travelledRoute.paths
              });
              allPoints.push(...travelledRoute.paths);
            } catch (error) {
              console.error('已操作地点到司机位置路线规划失败', error);
            }
          }
          try {
            const remainingRoute = await this.requestRoute([driverPoint, nextUnloadingPoint]);
            routeGeometries.push({
              id: 'driver-to-next-unloading-route',
              styleId: 'remaining',
              paths: remainingRoute.paths
            });
            this.showDistance(driverPoint, remainingRoute, '卸货地');
            allPoints.push(...remainingRoute.paths);
          } catch (error) {
            console.error('司机前往下一卸货地路线规划失败', error);
          }
          if (routeGeometries.length) {
            new TMap.MultiPolyline({
              map: this.map,
              styles: routeStyles,
              geometries: routeGeometries
            });
          }
        }
      } else if (isHeadingToFirstUnloading && driverPoint && unloadingPoints.length) {
        const routeGeometries = [];
        const routeStyles = {
          travelled: new TMap.PolylineStyle({
            color: '#2E9CFF',
            width: 9,
            lineCap: 'round',
            showArrow: true
          }),
          remaining: new TMap.PolylineStyle({
            color: '#D9CBBE',
            width: 9,
            lineCap: 'round',
            showArrow: true
          })
        };

        if (loadingPoints.length) {
          try {
            const shippingItems = Array.isArray(data.shippingLocationItems)
              ? data.shippingLocationItems
              : [];
            const unusedLoadingPoints = loadingPoints.slice();
            // 定位记录首项是最后操作地，倒序后才能还原实际装货顺序并连接司机当前位置。
            const operatedLoadingPoints = shippingItems.slice().reverse().map(item => {
              const pointIndex = unusedLoadingPoints.findIndex(point => (
                Number(item.addrLatitude) === point.getLat()
                && Number(item.addrLongitude) === point.getLng()
              ));
              return pointIndex >= 0 ? unusedLoadingPoints.splice(pointIndex, 1)[0] : null;
            }).filter(Boolean);
            const travelledPoints = (operatedLoadingPoints.length
              ? operatedLoadingPoints
              : loadingPoints).concat(driverPoint);
            const travelledRoute = await this.requestRoute(travelledPoints);
            routeGeometries.push({
              id: 'loading-to-driver-route',
              styleId: 'travelled',
              paths: travelledRoute.paths
            });
            allPoints.push(...travelledRoute.paths);
          } catch (error) {
            console.error('装货地到司机位置路线规划失败', error);
          }
        }
        try {
          const remainingPoints = [driverPoint].concat(unloadingPoints);
          const [remainingRoute, distanceRoute] = await Promise.all([
            this.requestRoute(remainingPoints),
            this.requestRoute([driverPoint, unloadingPoints[0]])
          ]);
          routeGeometries.push({
            id: 'first-unloading-route',
            styleId: 'remaining',
            paths: remainingRoute.paths
          });
          this.showDistance(driverPoint, distanceRoute, '卸货地');
          allPoints.push(...remainingRoute.paths);
        } catch (error) {
          console.error('司机前往第一个卸货地路线规划失败', error);
        }
        if (routeGeometries.length) {
          new TMap.MultiPolyline({
            map: this.map,
            styles: routeStyles,
            geometries: routeGeometries
          });
        }
      } else if (isArriveUnloadingRoute && operationStatusPoint) {
        const receivingItems = Array.isArray(data.receivingLocationItems)
          ? data.receivingLocationItems
          : [];
        const currentUnloadingPoint = operationStatusPoint.position;
        const operatedItems = receivingItems.slice(1);
        let operatedUnloadingPoints = unloadingPoints.filter(point => operatedItems.some(item => (
          Number(item.addrLatitude) === point.getLat()
          && Number(item.addrLongitude) === point.getLng()
        )));
        // 旧定位记录无坐标时，按记录数量回退，并排除 receivingLocationItems[0] 对应的当前操作地。
        if (!operatedUnloadingPoints.length && operatedItems.length) {
          operatedUnloadingPoints = unloadingPoints
            .filter(point => (
              point.getLat() !== currentUnloadingPoint.getLat()
              || point.getLng() !== currentUnloadingPoint.getLng()
            ))
            .slice(0, operatedItems.length);
        }
        const pendingUnloadingPoints = unloadingPoints.filter(point => {
          const isCurrentPoint = point.getLat() === currentUnloadingPoint.getLat()
            && point.getLng() === currentUnloadingPoint.getLng();
          const isOperatedPoint = operatedUnloadingPoints.some(operatedPoint => (
            operatedPoint.getLat() === point.getLat()
            && operatedPoint.getLng() === point.getLng()
          ));
          return !isCurrentPoint && !isOperatedPoint;
        });
        const routeGeometries = [];
        const routeStyles = {
          travelled: new TMap.PolylineStyle({
            color: '#2E9CFF',
            width: 9,
            lineCap: 'round',
            showArrow: true
          }),
          remaining: new TMap.PolylineStyle({
            color: '#D9CBBE',
            width: 9,
            lineCap: 'round',
            showArrow: true
          })
        };

        const isLastUnloadingOperation = [
          'arriveUploads', 'arriveReceiving', 'breakBulk', 'completeDischarge'
        ].includes(currentNode.nodeCode)
          && receivingItems.length === (Array.isArray(data.unloadingAddressList)
            ? data.unloadingAddressList.length
            : 0);
        const getSortedLocationPoints = items => items.slice()
          .sort((a, b) => Number(a.sortId || 0) - Number(b.sortId || 0))
          .map(item => {
            const latitude = Number(item.addrLatitude);
            const longitude = Number(item.addrLongitude);
            return Number.isFinite(latitude) && Number.isFinite(longitude)
              ? new TMap.LatLng(latitude, longitude)
              : null;
          })
          .filter(Boolean);
        // 操作最后一个卸货地时，卸货定位必须按 sortId 升序还原已行驶线路。
        const travelledPoints = isLastUnloadingOperation
          ? getSortedLocationPoints(Array.isArray(data.shippingLocationItems)
            ? data.shippingLocationItems
            : []).concat(getSortedLocationPoints(receivingItems))
          : loadingPoints.concat(operatedUnloadingPoints, currentUnloadingPoint);
        if (travelledPoints.length > 1) {
          try {
            const travelledRoute = await this.requestRoute(travelledPoints);
            routeGeometries.push({
              id: isLastUnloadingOperation
                ? 'sorted-loading-to-receiving-route'
                : 'loading-through-operated-to-current-unloading-route',
              styleId: 'travelled',
              paths: travelledRoute.paths
            });
            allPoints.push(...travelledRoute.paths);
          } catch (error) {
            console.error('已操作装卸货地路线规划失败', error);
          }
        }
        const remainingPoints = [currentUnloadingPoint].concat(pendingUnloadingPoints);
        if (!isLastUnloadingOperation && remainingPoints.length > 1) {
          try {
            const remainingRoute = await this.requestRoute(remainingPoints);
            routeGeometries.push({
              id: 'remaining-unloading-route',
              styleId: 'remaining',
              paths: remainingRoute.paths
            });
            allPoints.push(...remainingRoute.paths);
          } catch (error) {
            console.error('当前卸货地到其他卸货地路线规划失败', error);
          }
        }
        if (routeGeometries.length) {
          new TMap.MultiPolyline({
            map: this.map,
            styles: routeStyles,
            geometries: routeGeometries
          });
        }
      } else if (isLoadingOperationRoute && operationStatusPoint) {
        const shippingItems = Array.isArray(data.shippingLocationItems)
          ? data.shippingLocationItems
          : [];
        const currentLoadingPoint = operationStatusPoint.position;
        const operatedItems = shippingItems.slice(1);
        let operatedPoints = loadingPoints.filter(point => operatedItems.some(item => (
          Number(item.addrLatitude) === point.getLat()
          && Number(item.addrLongitude) === point.getLng()
        )));
        // 旧定位记录无坐标时，按记录数量回退，并排除 shippingLocationItems[0] 对应的当前操作地。
        if (!operatedPoints.length && operatedItems.length) {
          operatedPoints = loadingPoints
            .filter(point => (
              point.getLat() !== currentLoadingPoint.getLat()
              || point.getLng() !== currentLoadingPoint.getLng()
            ))
            .slice(0, operatedItems.length);
        }
        const routeGeometries = [];
        const travelledPoints = operatedPoints.concat(currentLoadingPoint);
        if (travelledPoints.length > 1) {
          try {
            const travelledRoute = await this.requestRoute(travelledPoints);
            routeGeometries.push({
              id: 'operated-to-current-loading-route',
              styleId: 'travelled',
              paths: travelledRoute.paths
            });
            allPoints.push(...travelledRoute.paths);
          } catch (error) {
            console.error('已操作装货地到当前装货地路线规划失败', error);
          }
        }
        // 操作最后一个装货地时直接前往卸货地；否则先经过尚未操作的下一装货地。
        const currentShippingItem = shippingItems[0];
        const isFinalLoadingOperation = ['arriveDelivery', 'beginningLoading']
          .includes(currentNode.nodeCode)
          && shippingItems.length === (Array.isArray(data.loadingAddressList)
            ? data.loadingAddressList.length
            : 0);
        const nextLoadingPoint = !isFinalLoadingOperation && currentShippingItem
          ? loadingPoints.find(point => !shippingItems.some(item => (
            Number(item.addrLatitude) === point.getLat()
            && Number(item.addrLongitude) === point.getLng()
          )))
          : null;
        const remainingPoints = [currentLoadingPoint]
          .concat(nextLoadingPoint ? [nextLoadingPoint] : [], unloadingPoints);
        if (remainingPoints.length > 1) {
          try {
            const remainingRoute = await this.requestRoute(remainingPoints);
            routeGeometries.push({
              id: 'current-loading-through-next-to-unloading-route',
              styleId: 'remaining',
              paths: remainingRoute.paths
            });
            allPoints.push(...remainingRoute.paths);
          } catch (error) {
            console.error('当前装货地经下一装货地到卸货地路线规划失败', error);
          }
        }
        if (routeGeometries.length) {
          new TMap.MultiPolyline({
            map: this.map,
            styles: {
              travelled: new TMap.PolylineStyle({
                color: '#2E9CFF',
                width: 9,
                lineCap: 'round',
                showArrow: true
              }),
              remaining: new TMap.PolylineStyle({
                color: '#D9CBBE',
                width: 9,
                lineCap: 'round',
                showArrow: true
              })
            },
            geometries: routeGeometries
          });
        }
      } else if (currentNode.nodeCode === 'receipt' || currentCode === 'receipt') {
        // 签收后分别按装货、卸货定位记录的 sortId 升序还原实际操作顺序。
        const getOperatedPoints = (items, points) => {
          const unusedPoints = points.slice();
          return (Array.isArray(items)
            ? items.slice().sort((a, b) => Number(a.sortId || 0) - Number(b.sortId || 0))
            : []).map(item => {
            const latitude = Number(item.addrLatitude);
            const longitude = Number(item.addrLongitude);
            let pointIndex = unusedPoints.findIndex(point => (
              Number.isFinite(latitude)
              && Number.isFinite(longitude)
              && latitude === point.getLat()
              && longitude === point.getLng()
            ));
            if (pointIndex < 0) pointIndex = 0;
            return pointIndex >= 0 ? unusedPoints.splice(pointIndex, 1)[0] : null;
          }).filter(Boolean);
        };
        const operatedLoadingPoints = getOperatedPoints(data.shippingLocationItems, loadingPoints);
        const operatedUnloadingPoints = getOperatedPoints(data.receivingLocationItems, unloadingPoints);
        const routePoints = (operatedLoadingPoints.length ? operatedLoadingPoints : loadingPoints)
          .concat(operatedUnloadingPoints.length ? operatedUnloadingPoints : unloadingPoints);
        if (routePoints.length > 1) {
          try {
            const route = await this.requestRoute(routePoints);
            new TMap.MultiPolyline({
              map: this.map,
              styles: {
                signed: new TMap.PolylineStyle({
                  color: '#2E9CFF',
                  width: 9,
                  lineCap: 'round',
                  showArrow: true
                })
              },
              geometries: [{ id: 'signed-route', styleId: 'signed', paths: route.paths }]
            });
            allPoints.push(...route.paths);
          } catch (error) {
            console.error('已操作装卸货地路线规划失败', error);
          }
        }
      } else if ((isHeadingToLoading || currentCode === 'start') && driverPoint && loadingPoints.length) {
        const completed = this.trackList.filter(item => item.nodeCode === 'completionLoading').length;
        const targetPoint = loadingPoints[Math.min(completed, loadingPoints.length - 1)];
        try {
          // 主线路覆盖司机、全部装货地和卸货地；距离气泡仅计算司机到下一装货地。
          const routePoints = [driverPoint].concat(loadingPoints, unloadingPoints);
          const [route, distanceRoute] = await Promise.all([
            this.requestRoute(routePoints),
            this.requestRoute([driverPoint, targetPoint])
          ]);
          new TMap.MultiPolyline({
            map: this.map,
            styles: {
              remaining: new TMap.PolylineStyle({
                color: '#D9CBBE',
                width: 9,
                lineCap: 'round',
                showArrow: true
              })
            },
            geometries: [{ id: 'remaining-route', styleId: 'remaining', paths: route.paths }]
          });
          this.showDistance(driverPoint, distanceRoute, '装货地');
          allPoints.push(...route.paths);
        } catch (error) {
          console.error('司机前往装货地路线规划失败', error);
        }
      } else if (currentCode === 'leavePhoto' && driverPoint && unloadingPoints.length) {
        const receivingItems = Array.isArray(data.receivingLocationItems) ? data.receivingLocationItems : [];
        const completed = receivingItems.length
          || this.trackList.filter(item => /completionUnloading|签收|回单/.test(item.nodeCode || '')).length;
        const targetPoint = unloadingPoints[Math.min(completed, unloadingPoints.length - 1)];
        try {
          const route = await this.requestRoute([driverPoint, targetPoint]);
          new TMap.MultiPolyline({
            map: this.map,
            styles: {
              remaining: new TMap.PolylineStyle({
                color: '#599fed',
                width: 9,
                borderWidth: 1,
                borderColor: '#ecf2fe',
                lineCap: 'round',
                showArrow: true
              })
            },
            geometries: [{ id: 'remaining-route', styleId: 'remaining', paths: route.paths }]
          });
          this.showDistance(driverPoint, route, '卸货地');
          allPoints.push(...route.paths);
        } catch (error) {
          console.error('司机前往卸货地路线规划失败', error);
        }
      }

      // 视野包含所有点位
      if (allPoints.length > 1) {
        const lats = allPoints.map(p => p.getLat());
        const lngs = allPoints.map(p => p.getLng());
        const southWest = new TMap.LatLng(Math.min(...lats), Math.min(...lngs));
        const northEast = new TMap.LatLng(Math.max(...lats), Math.max(...lngs));
        this.map.fitBounds(new TMap.LatLngBounds(southWest, northEast), { padding: {top:180,left:60,right:60,bottom:60} });
      }
    },
    // 到达、开始或完成装卸货时，获取当前操作地点及对应状态信息。
    getOperationStatusPoint(data) {
      const currentNode = (data.trackList && data.trackList[0]) || {};
      if (this.isAllLoadingCompleted(data)) return null;
      const receivingItems = Array.isArray(data.receivingLocationItems)
        ? data.receivingLocationItems
        : [];
      // 完成某站卸货并前往下一站时，已卸货地址统一展示“已签收”，不保留操作中气泡。
      if (currentNode.nodeCode === 'completeDischarge'
        && data.orderLinkCode === 'leavePhoto'
        && receivingItems.length) return null;
      const isArriveDelivery = ['arriveDelivery', 'beginningLoading','completionLoading']
        .includes(currentNode.nodeCode);
      const isArriveUnloading = ['arriveUploads', 'arriveReceiving', 'breakBulk', 'completeDischarge']
        .includes(currentNode.nodeCode);
      const code = isArriveDelivery || isArriveUnloading
        ? currentNode.nodeCode
        : (data.orderLinkCode || currentNode.nodeCode);
      const loadingCodes = ['arriveDelivery', 'beginningLoading', 'completionLoading'];
      const unloadingCodes = ['arriveUploads', 'arriveReceiving', 'breakBulk', 'completeDischarge'];
      const isLoading = loadingCodes.includes(code);
      const isUnloading = unloadingCodes.includes(code);
      if (!isLoading && !isUnloading) return null;

      const orderItems = isLoading
        ? data.shippingLocationItems
        : (data.receivingLocationItems || data.unloadingLocationItems);
      const nodeItems = isLoading
        ? currentNode.shippingLocationItems
        : (currentNode.receivingLocationItems || currentNode.unloadingLocationItems);
      const items = Array.isArray(orderItems) && orderItems.length ? orderItems : nodeItems;
      const addressList = isLoading ? (data.loadingAddressList || []) : (data.unloadingAddressList || []);
      let operationAddress;
      if (isArriveDelivery || isArriveUnloading) {
        // 到达装卸货地时必须通过定位记录坐标匹配地址，防止多地址场景气泡错位。
        const isLastAddressOperation = Array.isArray(items)
          && items.length === addressList.length;
        const isLeavingCompletedUnloading = isUnloading
          && currentNode.nodeCode === 'completeDischarge'
          && data.orderLinkCode === 'leavePhoto';
        // 最后一个地址操作或完成卸货后离场时，sortId 最大项是司机最近记录的地址。
        const locationItems = Array.isArray(items)
          && (isLastAddressOperation || isLeavingCompletedUnloading)
          ? items.slice().sort((a, b) => Number(b.sortId || 0) - Number(a.sortId || 0)).slice(0, 1)
          : (Array.isArray(items) ? items.slice(0, 1) : []);
        operationAddress = locationItems.reduce((matched, item) => matched || addressList.find(address => (
          Number(item.addrLatitude) === Number(address.latitude)
          && Number(item.addrLongitude) === Number(address.longitude)
        )), null);
        if (!operationAddress) return null;
      } else {
        // 其他装卸货节点沿用定位记录数量推断当前操作地址。
        const addressIndex = Array.isArray(items) && items.length ? items.length - 1 : 0;
        operationAddress = addressList[addressIndex];
      }
      const latitude = Number(operationAddress && operationAddress.latitude);
      const longitude = Number(operationAddress && operationAddress.longitude);
      if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;
      return {
        position: new TMap.LatLng(latitude, longitude),
        styleId: isLoading ? 'start' : 'end',
        code,
        statusText: currentNode.nodeName || {
          arriveDelivery: '到达装货地',
          beginningLoading: '开始装货',
          completionLoading: '完成装货',
          arriveUploads: '到达卸货地',
          arriveReceiving: '开始卸货',
          breakBulk: '卸货中',
          completeDischarge: '完成卸货'
        }[code],
        address: (operationAddress && operationAddress.factoryName?operationAddress.factoryName:operationAddress.title) || ''
      };
    },
    // 多装货地址处于装货相关阶段时，根据装货定位记录标识已经完成装货的地址。
    getLoadedAddressStatusPoints(data, operationStatusPoint) {
      const currentNode = (data.trackList && data.trackList[0]) || {};
      const visibleCodes = ['leavePhoto', 'arriveDelivery', 'beginningLoading', 'completionLoading'];
      const addressList = Array.isArray(data.loadingAddressList) ? data.loadingAddressList : [];
      const shippingItems = Array.isArray(data.shippingLocationItems) ? data.shippingLocationItems : [];
      if (this.isAllLoadingCompleted(data)
        || addressList.length <= 1
        || !visibleCodes.includes(currentNode.nodeCode)
        || !shippingItems.length) {
        return [];
      }

      const matchedAddresses = [];
      shippingItems.forEach(item => {
        const itemLatitude = Number(item.addrLatitude);
        const itemLongitude = Number(item.addrLongitude);
        if (!Number.isFinite(itemLatitude) || !Number.isFinite(itemLongitude)
          || !itemLatitude || !itemLongitude) return;
        const address = addressList.find(candidate => (
          itemLatitude === Number(candidate.latitude)
          && itemLongitude === Number(candidate.longitude)
        ));
        if (address && !matchedAddresses.includes(address)) matchedAddresses.push(address);
      });
      // 兼容旧定位记录缺少地址坐标的情况，此时按记录数量回退到地址顺序。
      const loadedAddresses = matchedAddresses.length
        ? matchedAddresses
        : addressList.slice(0, Math.min(shippingItems.length, addressList.length));
      return loadedAddresses.map(address => {
        const latitude = Number(address.latitude);
        const longitude = Number(address.longitude);
        if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;
        // 正在操作的装货地继续展示原节点气泡，避免被“已装货”气泡覆盖。
        if (operationStatusPoint
          && latitude === operationStatusPoint.position.getLat()
          && longitude === operationStatusPoint.position.getLng()) return null;
        return {
          position: new TMap.LatLng(latitude, longitude),
          address: (address.factoryName ? address.factoryName : address.title) || ''
        };
      }).filter(Boolean);
    },
    // 离开装货地且定位记录覆盖全部装货地址时，订单已经进入前往卸货地阶段。
    isAllLoadingCompleted(data) {
      const currentNode = (data.trackList && data.trackList[0]) || {};
      const addressList = Array.isArray(data.loadingAddressList) ? data.loadingAddressList : [];
      const shippingItems = Array.isArray(data.shippingLocationItems) ? data.shippingLocationItems : [];
      return currentNode.nodeCode === 'leavePhoto'
        && addressList.length > 0
        && shippingItems.length === addressList.length;
    },
    // 卸货操作期间识别当前地址之外已经签收的地址。
    getSignedAddressStatusPoints(data, operationStatusPoint) {
      const currentNode = (data.trackList && data.trackList[0]) || {};
      const visibleCodes = ['arriveUploads', 'arriveReceiving', 'breakBulk', 'completeDischarge'];
      const addressList = Array.isArray(data.unloadingAddressList) ? data.unloadingAddressList : [];
      const receivingItems = Array.isArray(data.receivingLocationItems) ? data.receivingLocationItems : [];
      const isLastUnloadingOperation = visibleCodes.includes(currentNode.nodeCode)
        && receivingItems.length === addressList.length;
      const isLeavingCompletedUnloading = currentNode.nodeCode === 'completeDischarge'
        && data.orderLinkCode === 'leavePhoto';
      const sortedReceivingItems = receivingItems.slice()
        .sort((a, b) => Number(a.sortId || 0) - Number(b.sortId || 0));
      // 前往下一卸货地时全部记录均已完成；仍在最后一站操作时仅排除当前地址。
      const signedItems = isLeavingCompletedUnloading
        ? sortedReceivingItems
        : isLastUnloadingOperation
          ? sortedReceivingItems.slice(0, -1)
        : receivingItems.slice(1);
      if (!visibleCodes.includes(currentNode.nodeCode) || !signedItems.length) return [];

      const matchedAddresses = [];
      signedItems.forEach(item => {
        const itemLatitude = Number(item.addrLatitude);
        const itemLongitude = Number(item.addrLongitude);
        if (!Number.isFinite(itemLatitude) || !Number.isFinite(itemLongitude)
          || !itemLatitude || !itemLongitude) return;
        const address = addressList.find(candidate => (
          itemLatitude === Number(candidate.latitude)
          && itemLongitude === Number(candidate.longitude)
        ));
        if (address && !matchedAddresses.includes(address)) matchedAddresses.push(address);
      });
      // 兼容旧定位记录缺少地址坐标的情况，并排除当前正在操作的卸货地。
      const signedAddresses = matchedAddresses.length
        ? matchedAddresses
        : addressList.filter(address => {
          if (!operationStatusPoint) return true;
          return Number(address.latitude) !== operationStatusPoint.position.getLat()
            || Number(address.longitude) !== operationStatusPoint.position.getLng();
        }).slice(0, signedItems.length);
      return signedAddresses.map(address => {
        const latitude = Number(address.latitude);
        const longitude = Number(address.longitude);
        if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;
        return {
          position: new TMap.LatLng(latitude, longitude),
          address: (address.factoryName ? address.factoryName : address.title) || ''
        };
      }).filter(Boolean);
    },
    // 腾讯路线规划同一秒请求过多会失败，并发规划需排队并间隔 500ms。
    enqueueRouteRequest() {
      const previous = this.routeRequestQueue || Promise.resolve();
      let release;
      const current = new Promise(resolve => {
        release = resolve;
      });
      this.routeRequestQueue = previous.catch(() => {}).then(async () => {
        const wait = this.lastRouteRequestAt
          ? Math.max(0, 500 - (Date.now() - this.lastRouteRequestAt))
          : 0;
        if (wait) await new Promise(resolve => setTimeout(resolve, wait));
        this.lastRouteRequestAt = Date.now();
        release();
      });
      return current;
    },
    async requestRoute(points) {
      await this.enqueueRouteRequest();
      const coordinates = points.map(point => `${point.getLat()},${point.getLng()}`);
      const params = {
        from: coordinates[0],
        to: coordinates[coordinates.length - 1]
      };
      if (coordinates.length > 2) params.waypoints = coordinates.slice(1, -1).join(';');
      const result = await directionDriving(params);
      const route = result.result.routes[0];
      const coords = route.polyline.slice();
      for (let index = 2; index < coords.length; index += 1) {
        coords[index] = Number(coords[index - 2]) + Number(coords[index]) / 1000000;
      }
      const paths = [];
      for (let index = 0; index < coords.length; index += 2) {
        paths.push(new TMap.LatLng(coords[index], coords[index + 1]));
      }
      return {
        paths,
        distance: route.distance,
        duration: route.duration
      };
    },
    showDistance(position, route, targetName) {
      this.acceptedOverlay = new Donut({
        map: this.map,
        position,
        isShowPickup: true,
        offsetY: 30,
        data: {
          text: `司机距离${targetName}`,
          contentText: '距离',
          meil: (Number(route.distance || 0) / 1000).toFixed(2),
          time: formatMinutes(Number(route.duration || 0))
        }
      });
    },
    // 司机接单后在当前位置展示提货倒计时，超过 deliveryTime 时显示“已超时”。
    showAcceptedOrder(position) {
      if (this.acceptedOverlay) this.acceptedOverlay.destroy();
      this.acceptedOverlay = new Donut({
        map: this.map,
        position,
        isShowPickup: false,
        offsetY: 30,
        deliveryTime: this.formatPickupCountdown(this.orderData.deliveryTime, this.currentTimestamp),
        data: {
          text: '司机已接单',
          contentText: ''
        }
      });
    },
    // 在装卸货 Marker 上方展示当前状态和地址。
    showOperationStatus(point) {
      if (this.acceptedOverlay) this.acceptedOverlay.destroy();
      this.acceptedOverlay = new Donut({
        map: this.map,
        position: point.position,
        isShowPickup: false,
        offsetY: 30,
        code: point.code,
        data: {
          text: point.statusText,
          contentText: point.address
        }
      });
    },
    showLoadedAddressStatuses(points) {
      this.destroyLoadedAddressOverlays();
      this.loadedAddressOverlays = points.map(point => new Donut({
        map: this.map,
        position: point.position,
        isShowPickup: false,
        offsetY: 30,
        code: 'completionLoading',
        data: {
          text: '已装货',
          contentText: point.address
        }
      }));
    },
    destroyLoadedAddressOverlays() {
      this.loadedAddressOverlays.forEach(overlay => overlay.destroy());
      this.loadedAddressOverlays = [];
    },
    showSignedAddressStatuses(points) {
      this.destroySignedAddressOverlays();
      this.signedAddressOverlays = points.map(point => new Donut({
        map: this.map,
        position: point.position,
        isShowPickup: false,
        offsetY: 30,
        code: 'completeDischarge',
        data: {
          text: '已签收',
          contentText: point.address
        }
      }));
    },
    destroySignedAddressOverlays() {
      this.signedAddressOverlays.forEach(overlay => overlay.destroy());
      this.signedAddressOverlays = [];
    },
    /* ==================== 工具方法 ==================== */
    toChinese(num) {
      return CHINESE_NUMBERS[num - 1] || num;
    },
    formatAddress(addr) {
      return `${addr.province || ''}${addr.city || ''}${addr.district || ''}${addr.detailedAddress || ''}` || '--';
    },
    formatContact(addr) {
      const name = addr.contactName || addr.contacts || addr.linkman || '';
      const phone = addr.contactPhone || addr.contactsPhone || addr.phone || '';
      const text = `${name}  ${phone}`.trim();
      return text || '--';
    },
    getNodePhotos(node) {
      if (!node.feedbackPhoto) return [];
      return node.feedbackPhoto.split(';').filter(Boolean);
    },
    copyOrderNumber() {
      const orderNumber = this.orderData.orderNumber;
      if (!orderNumber) return;
      const textarea = document.createElement('textarea');
      textarea.value = orderNumber;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      this.$message.success('复制成功');
    },
    goHome() {
      this.$router.push('/home');
    },
    scrollToSection(selector) {
      const el = document.querySelector(selector);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    },
    backTopHandle() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    linkServerHandle() {
      this.showCustomerService = true;
      if (this.$Loading) this.$Loading();
      setTimeout(() => {
        this.showLinkServe = false;
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
.share-order-details {
  background: #eff0f4;
  min-height: 100vh;
  text-align: left;

  /* ===== 顶部导航 ===== */
  .page-nav-header {
    width: 100%;
    height: 88px;
    padding: 0 360px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #F1BC3F;

    .header-logo {
      width: 192px;
      height: 48px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .header-nav {
      display: flex;
      align-items: center;
      .nav-item {
        margin-left: 48px;
        font-size: 18px;
        line-height: 26px;
        color: #ffffff;
        font-family: PingFangSC;
        cursor: pointer;
        &:hover {
          opacity: 0.85;
        }
      }
    }
  }

  /* ===== 订单卡片 ===== */
  .order-card {
    width: 1400px;
    margin: 16px auto 40px;
    background: #ffffff;
    border-radius: 4px;
    padding: 24px 24px 48px;
    box-sizing: border-box;
    position: relative;
  }

  .order-info-bar {
    width: 1192px;
    height: 66px;
    margin: 16px auto 24px;
    padding: 0 24px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 4px 8px 0px rgba(51, 51, 51, 0.12);
    display: flex;
    align-items: center;
    position: absolute;
    top: 26px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1001;

    .order-number-box {
      display: flex;
      align-items: center;
      .bee-icon {
        width: 22px;
        height: 17px;
        margin-right: 8px;
      }
      .order-number {
        font-size: 18px;
        color: #333333;
        letter-spacing: 0.3px;
      }
      .copy-btn {
        margin-left: 16px;
        padding: 2px 10px;
        font-size: 14px;
        color: #333333;
        border: 1px solid #eff0f4;
        border-radius: 2px;
        cursor: pointer;
        &:hover {
          color: #f1bc3f;
          border-color: #f1bc3f;
        }
      }
    }
    .order-state {
      margin-left: 40px;
      font-size: 24px;
      font-weight: 500;
      color: #ff484a;
      white-space: nowrap;
    }
    .order-time {
      margin-left: 48px;
      font-size: 18px;
      color: #333333;
      white-space: nowrap;
      position: relative;
      .pickup-time-tip {
        position: absolute;
        right: 0;
        bottom: calc(100% + 10px);
        padding: 4px 8px;
        border-radius: 2px;
        background: #ff484a;
        color: #ffffff;
        font-size: 14px;
        line-height: 20px;
        font-weight: 400;
        white-space: nowrap;
        &::after {
          content: '';
          position: absolute;
          top: 100%;
          left: 12px;
          border: 5px solid transparent;
          border-top-color: #ff484a;
        }
      }
    }
    .order-city {
      margin-left: auto;
      display: flex;
      align-items: center;
      .city-name {
        font-size: 24px;
        font-weight: bold;
        color: #333333;
      }
      .arrow-icon {
        width: 48px;
        height: 48px;
        margin: 0 12px;
      }
    }
  }

  .map-container {
    width: 100%;
    height: 731px;
    background: #f5f5f5;
    border-radius: 4px;
    overflow: hidden;
  }

  /* ===== 司机信息 ===== */
  .driver-info {
    display: flex;
    align-items: center;
    margin: 40px 16px 0;

    .driver-avatar {
      width: 72px;
      height: 72px;
      border-radius: 50%;
      overflow: hidden;
      flex-shrink: 0;
      background: #f8f8f8;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .driver-detail {
      margin-left: 16px;
      .driver-name {
        font-size: 24px;
        line-height: 36px;
        color: #241f1b;
      }
      .driver-car {
        font-size: 16px;
        line-height: 24px;
        color: #3d3833;
        margin-top: 4px;
      }
    }
  }

  /* ===== Tab ===== */
  .tabs-bar {
    display: flex;
    margin: 48px 16px 0;

    .tab-item {
      position: relative;
      margin-right: 60px;
      padding-bottom: 24px;
      font-size: 24px;
      line-height: 36px;
      color: #241f1b;
      cursor: pointer;

      &.active {
        color: #f1bc3f;
      }
      .tab-underline {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 97px;
        height: 2px;
        background: #f1bc3f;
      }
    }
  }
  .tabs-divider {
    height: 1px;
    background: #eeeeee;
    margin: 0 16px;
  }
  .tab-content {
    padding: 32px 16px 0;
    min-height: 300px;
  }

  /* ===== 订单详情：地址 ===== */
  .address-block {
    margin-bottom: 36px;

    .address-block-title {
      font-size: 16px;
      line-height: 24px;
      color: #3d3833;
      margin-bottom: 12px;
    }
    .address-list {
      display: flex;
      flex-wrap: wrap;
      gap: 18px;
    }
    .address-empty {
      font-size: 14px;
      color: #85807b;
    }
    .address-card {
      width: 428px;
      background: #f8f8f8;
      border-radius: 8px;
      padding: 16px 24px;
      box-sizing: border-box;

      .address-tag {
        font-size: 14px;
        line-height: 22px;
        &.loading-tag {
          color: #ffbd2d;
        }
        &.unloading-tag {
          color: #ec892e;
        }
      }
      .address-name {
        margin-top: 6px;
        font-size: 18px;
        font-weight: 500;
        line-height: 26px;
        color: #3d3833;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .address-detail {
        margin-top: 4px;
        font-size: 14px;
        line-height: 22px;
        color: #85807b;
        min-height: 44px;
      }
      .address-contact {
        margin-top: 10px;
        padding: 6px 12px;
        background: #efefef;
        border-radius: 4px;
        font-size: 14px;
        line-height: 22px;
        color: #3d3833;
        display: flex;
        justify-content: space-between;
      }
    }
  }

  /* ===== 订单详情：字段 ===== */
  .order-fields {
    display: flex;
    margin-top: 12px;

    .fields-column {
      flex: 1;
      &:not(:first-child) {
        margin-left: 80px;
      }
    }
    .field-item {
      display: flex;
      justify-content: space-between;
      margin-bottom: 24px;

      .field-label {
        font-size: 16px;
        line-height: 24px;
        color: #74797e;
        white-space: nowrap;
      }
      .field-value {
        font-size: 16px;
        line-height: 24px;
        color: #333333;
        text-align: right;
        margin-left: 16px;
        word-break: break-all;
      }
    }
  }

  /* ===== 物流节点 ===== */
  .track-list {
    padding-top: 8px;

    .track-item {
      display: flex;

      .track-left {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 18px;

        .track-node-icon {
          width: 20px;
          height: 20px;
          margin-top: 4px;
        }
        .track-line {
          flex: 1;
          width: 1px;
          background: #e5e5e5;
        }
      }
      .track-content {
        flex: 1;
        padding-bottom: 40px;

        .track-name {
          font-size: 18px;
          font-weight: 500;
          line-height: 26px;
          color: #3d3833;
        }
        .track-info {
          margin-top: 8px;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          font-size: 16px;
          line-height: 24px;
          color: #3d3833;

          .track-clock-icon {
            width: 20px;
            height: 20px;
            margin-right: 8px;
          }
          .track-people {
            margin-right: 12px;
          }
          .track-time {
            margin-right: 12px;
          }
          .track-address {
            color: #3d3833;
          }
        }
        .track-photos {
          margin-top: 12px;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;

          .track-photo {
            width: 75px;
            height: 75px;
            border-radius: 8px;
            background: #f8f8f8;
            cursor: pointer;
          }
        }
      }
    }
  }

  .empty-tip {
    text-align: center;
    font-size: 16px;
    color: #85807b;
    padding: 80px 0;
  }

  /* ===== 冷藏数据 ===== */
  .cold-axis-title {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #85807b;
    padding: 0 8px;
  }
  .cold-chart {
    width: 100%;
    height: 420px;
    margin-top: 8px;
  }

  /* ===== 服务范围 ===== */
  .scope-of-services {
    background: #f5f5f5;
    padding: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .server-title {
      width: 1192px;
      text-align: left;
      span {
        display: inline-block;
      }
      .text-title {
        font-size: 24px;
        font-weight: 500;
        color: #f1bc3f;
      }
      .latter-title {
        margin-left: 10px;
        font-size: 14px;
        color: #acacac;
      }
    }
    .server-content {
      margin-top: 25px;
      width: 1192px;
      text-align: justify;
      font-size: 16px;
      color: #7b7b7b;
    }
  }

  /* ===== 右侧悬浮按钮 ===== */
  .right-btn {
    position: fixed;
    right: 0;
    top: 80vh;
    z-index: 9;
  }
  .suspension-icon {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 20px;
    background: #ffffff;
    box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.08);
    border-radius: 16px 0px 0px 16px;
  }
  .online-customer-service-icon {
    margin-top: 40px;
  }
  .suspension-icon-item-icon {
    width: 24px;
    height: 24px;
    font-size: 0;
  }
  .name {
    margin-left: 15px;
    font-size: 14px;
    color: #7b7b7b;
  }
}
</style>
